/* GlowLux — globalne skrypty */
(function () {
  var body = document.body;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- spadające świąteczne emotki ---------- */
  function snow() {
    if (body.getAttribute('data-snow') !== 'true' || reduce) return;
    var items = (body.getAttribute('data-snow-items') || '❄️,🎄,🎁,⭐').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var count = parseInt(body.getAttribute('data-snow-count') || '8', 10);
    if (window.innerWidth < 600) count = Math.max(3, Math.round(count * 0.7));
    /* prędkość 1 (bardzo wolno) – 10 (szybko); czas spadania w sekundach */
    var speed = parseInt(body.getAttribute('data-snow-speed') || '3', 10);
    var base = 44 - speed * 3.2;
    var box = document.createElement('div');
    box.className = 'gl-snow';
    box.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < count; i++) {
      var f = document.createElement('div');
      var s = document.createElement('span');
      f.className = 'gl-flake';
      s.textContent = items[i % items.length];
      var dur = base + Math.random() * base * 0.5;
      f.style.left = (Math.random() * 100) + 'vw';
      f.style.fontSize = (14 + Math.random() * 12) + 'px';
      f.style.opacity = (0.45 + Math.random() * 0.4).toFixed(2);
      f.style.animationDuration = dur + 's';
      f.style.animationDelay = (-Math.random() * dur) + 's';
      s.style.animationDuration = (4 + Math.random() * 3) + 's';
      f.appendChild(s);
      box.appendChild(f);
    }
    body.appendChild(box);
  }

  /* ---------- pojawianie się przy przewijaniu ---------- */
  function reveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- odliczanie do końca promocji ---------- */
  function countdowns() {
    var raw = (body.getAttribute('data-promo-end') || '').trim();
    var wraps = document.querySelectorAll('[data-countdown]');
    if (!wraps.length) return;
    var end = raw ? new Date(raw.replace(' ', 'T')) : null;
    if (!end || isNaN(end.getTime())) { wraps.forEach(function (w) { w.hidden = true; }); return; }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = Math.max(0, end.getTime() - Date.now());
      if (diff <= 0) { wraps.forEach(function (w) { w.hidden = true; }); return; }
      var d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24, m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
      wraps.forEach(function (w) {
        w.hidden = false;
        var dEl = w.querySelector('[data-d]');
        if (dEl) { dEl.textContent = d; dEl.parentNode.hidden = d === 0; }
        w.querySelector('[data-h]').textContent = pad(h);
        w.querySelector('[data-m]').textContent = pad(m);
        w.querySelector('[data-s]').textContent = pad(s);
      });
      setTimeout(tick, 1000);
    }
    tick();
  }

  /* ---------- rotujący pasek ogłoszeń ---------- */
  function announcement() {
    document.querySelectorAll('[data-ann]').forEach(function (bar) {
      var items = bar.querySelectorAll('.gl-ann__item');
      if (items.length < 2) { if (items[0]) items[0].classList.add('is-on'); return; }
      var i = 0, ms = (parseInt(bar.getAttribute('data-ann'), 10) || 4) * 1000;
      items[0].classList.add('is-on');
      setInterval(function () {
        var cur = items[i];
        cur.classList.remove('is-on'); cur.classList.add('is-out');
        setTimeout(function () { cur.classList.remove('is-out'); }, 500);
        i = (i + 1) % items.length;
        items[i].classList.add('is-on');
      }, ms);
    });
  }

  /* ---------- menu mobilne ---------- */
  function menu() {
    var m = document.getElementById('gl-menu');
    if (!m) return;
    document.querySelectorAll('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { m.classList.add('is-open'); body.style.overflow = 'hidden'; }); });
    m.querySelectorAll('[data-menu-close], a').forEach(function (b) { b.addEventListener('click', function () { m.classList.remove('is-open'); body.style.overflow = ''; }); });
  }

  /* ---------- przyciski "kup teraz" w sekcjach ---------- */
  function buyLinks() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-go-buy]');
      if (!t) return;
      var buy = document.querySelector('[data-buybox]');
      if (!buy) return;
      e.preventDefault();
      var pick = t.getAttribute('data-go-buy');
      if (pick !== '') {
        var radios = buy.querySelectorAll('input[name="gl-pack"]');
        var r = radios[parseInt(pick, 10)];
        if (r && !r.disabled) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      var target = buy.querySelector('[data-packs]') || buy;
      var y = target.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  }

  function init() { snow(); reveal(); countdowns(); announcement(); menu(); buyLinks(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
